import {
  BasicButton,
  Dialog,
  Modal,
  ModalTrigger,
} from "@certn/cascadia-react";
import { useTranslation } from "react-i18next";

import { CreateWebhookForm } from "./Form";

interface Props {
  apiConfigurationID: string;
  onSuccess: () => void;
}

export function CreateWebhookModal({ apiConfigurationID, onSuccess }: Props) {
  const { t } = useTranslation();

  return (
    <ModalTrigger
      trigger={() => (
        <BasicButton testID="create-webhook">{t("Create Webhook")}</BasicButton>
      )}
    >
      <Modal testID="create-webhook-modal">
        <Dialog>
          {({ close }) => (
            <CreateWebhookForm
              apiConfigurationID={apiConfigurationID}
              close={close}
              onSuccess={onSuccess}
            />
          )}
        </Dialog>
      </Modal>
    </ModalTrigger>
  );
}
